import { observer } from 'mobx-react';
import React from 'react';
import Tips from '../components/Tips';
import Uploader from '../components/Uploader';
// import { useStore } from '../stores';

const Home = observer(() => {

    // const { UserStore } = useStore();
    return (
        <>
            <h1 style={{ color: '#1890ff' }}>Home</h1>
            <Tips>请先登录再上传！！！</Tips>
            <Uploader />
        </>
    )
});

export default Home;